<template>
  <b-modal ref="fuelTank-card-modal" @ok="fuelTankCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.fuelTanks.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="name"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.volume"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          v-model="volume"
          :state="isVolumeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.height"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="100000000000"
          v-model="height"
          :state="isHeightValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.density"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="fuelDensity"
          :state="isFuelDensityValid"
          type="number"
          min="0"
          max="1"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.shape"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="shape"
          :options="shapeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.serialNumberOfLevelGauge"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="serialNumberOfLevelGauge"
          :state="isSerialNumberOfLevelGaugeValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.isActive"
        label-for="input-horizontal"
      >
        <b-form-checkbox
            v-model="isActive"
            :value="1"
            :unchecked-value="0"
          >
          </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.startDate"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="startDate"
          :state="isStartDateValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.lastCheckDate"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="lastCheckDate"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.tanksId"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="tanksId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.vehicleId"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="9999999999"
          v-model="vehicleId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns.sensorId"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="65535"
          v-model="sensorId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
    <div v-if="!isFormValid" class="text-danger mt-2" style="font-size: 13px">
      {{ validationErrorMessage }}
    </div>
  </b-modal>
</template>

<script>

import { azkService, utilsService } from "../../../../services";

export default {
  name: "CreateFuelTankPage",
  props: {
    fuelDepos: Array,
    fuelTanks: Array,
  },
  components: {},
  data() {
    return {
      isFormValid: true,
      validationErrorMessage: null,
      fuelDepoOptions: [],
      name: null,
      volume: null,
      height: null,
      fuelDensity: null,
      shape: null,
      serialNumberOfLevelGauge: null,
      isActive: null,
      startDate: null,
      lastCheckDate: null,
      fuelDepoId: null,
      tanksId: null,
     
      isNameValid: null,
      isVolumeValid: null,
      isHeightValid: null,
      isFuelDensityValid: null,
      isSerialNumberOfLevelGaugeValid: null,
      isStartDateValid: null,
      isFuelDepoValid: null
    };
  },
  computed: {
    shapeOptions() {
      const shapeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.fuelTanks.shapeOptions
          .length;
        i++
      ) {
        shapeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.fuelTanks
              .shapeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.fuelTanks
            .shapeOptions[i].value,
        });
      }
      return shapeOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    open() {
      this.name = null;
      this.volume = null;
      this.height = null;
      this.fuelDensity = null;
      this.serialNumberOfLevelGauge = null;
      this.shape = null;
      this.fuelDepoId = null;
      this.isActive = 1;
      this.startDate = null;
      this.lastCheckDate = null;
      this.tanksId = null;
      
      this.validationErrorMessage = null;
      this.isNameValid = null;
      this.isVolumeValid = null;
      this.isHeightValid = null;
      this.isFuelDensityValid = null;
      this.isSerialNumberOfLevelGaugeValid = null;
      this.isStartDateValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["fuelTank-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.name) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      if (!this.volume) {
        this.isVolumeValid = false;
        isValid = false;
      } else {
        this.isVolumeValid = null;
      }

      if (!this.height) {
        this.isHeightValid = false;
        isValid = false;
      } else {
        this.isHeightValid = null;
      }

      if (!this.fuelDensity) {
        this.isFuelDensityValid = false;
        isValid = false;
      } else {
        this.isFuelDensityValid = null;
      }

      if (!this.serialNumberOfLevelGauge) {
        this.isSerialNumberOfLevelGaugeValid = false;
        isValid = false;
      } else {
        this.isSerialNumberOfLevelGaugeValid = null;
      }

      if (!this.startDate) {
        this.isStartDateValid = false;
        isValid = false;
      } else {
        this.isStartDateValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      this.isFormValid = isValid;
      return isValid;
    },
    async fuelTankCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const fuelTank = this.fuelTanks.find(x => x.fuelDepoId == fuelDepoId);

      const fuelTankCard = {
        name: this.name,
        volume: parseInt(this.volume),
        height: parseInt(this.height),
        fuelDensity: parseFloat(this.fuelDensity),
        serialNumberOfLevelGauge: this.serialNumberOfLevelGauge,
        isActive: this.isActive,
        startDate: this.startDate != null ? this.startDate.getTime() / 1000 : null,
        lastCheckDate: this.lastCheckDate != null ? this.lastCheckDate.getTime() / 1000 : null,
        shape: parseInt(this.shape),
        tanksId: this.tanksId ? this.tanksId.split(",") : null,
        clientId: fuelTank.clientId,
        fuelDepoId: fuelDepoId
      };

      const createFuelTankResponse = await azkService.createFuelTank(fuelTankCard);

      if (
        createFuelTankResponse.isSuccess &&
        createFuelTankResponse.data &&
        createFuelTankResponse.data.countInsertedRows == 1
      ) {
        this.$emit("fuelTankCreatedSuccessEvent", this.fuelTank);
      } else {
        this.$emit("fuelTankCreatedFailEvent");
      }
    },
  },
};
</script>
